import { render, staticRenderFns } from "./EditorText.vue?vue&type=template&id=f2490440&"
import script from "./EditorText.vue?vue&type=script&lang=js&"
export * from "./EditorText.vue?vue&type=script&lang=js&"
import style0 from "./EditorText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2490440')) {
      api.createRecord('f2490440', component.options)
    } else {
      api.reload('f2490440', component.options)
    }
    module.hot.accept("./EditorText.vue?vue&type=template&id=f2490440&", function () {
      api.rerender('f2490440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/EditorText.vue"
export default component.exports